import { Handler } from '../../../Shared/Application/UseCases/Handler';
import { publicStoreCredentialsHandler } from '../../../Shared/Domain/publicStoreCredentialsHandler';
export class UpdateCustomerInfoHandler extends Handler {
  constructor(customerRepository, authRepository) {
    super();
    this.customerRepository = customerRepository;
    this.authRepository = authRepository;
  }
  handle(input) {
    return publicStoreCredentialsHandler(this.authRepository, credentials => this.customerRepository.updateCustomer(input.customer, credentials.accessToken));
  }
}
